import React, {forwardRef} from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './button.component.module.styl';
import {FlatButton} from './flat-button/flat-button.component';

import type {FlatButtonProps} from './flat-button/flat-button.component';

const classNames = withCssModule(styles);

/**
 * @component
 * @name ButtonLink
 * @deprecated It will be removed in 6 months 03-04-2026. Use FlatButton instead
 * @description A button that looks like a link
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/story/buttons-button--link-buttons}
 * */
export const ButtonLink = forwardRef<HTMLButtonElement, FlatButtonProps>(
    function ButtonLink({
        children,
        role = 'link',
        className,
        ...props
    }, ref) {
        return (
            <FlatButton
                {...props}
                role={role}
                className={classNames('button_link', className)}
                ref={ref}>
                {children}
            </FlatButton>
        );
    },
);

ButtonLink.displayName = 'ButtonLink';
